export default __webpack_public_path__ + "static/media/behance.3ef5a792.svg";